<template>
<div class="chapter">
<div class="inner_page">
<div id="V4305ebook-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CT para-style-override-1" id="toc_marker-3"><span class="char-style-override-2">Also by John Lawton</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">1963</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">Black Out</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">Old Flames</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">A Little White Death</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">Riptide</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">Blue Rondo</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">Second Violin</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">A Lily of the Field</span></p>
<p class="BT-1st-Para para-style-override-2"><span class="char-style-override-3">Then We Take Berlin</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4305ebook2.vue?7fe33868